import WiseView from './WiseView.vue';
import { frontendURL } from '../../../helper/URLHelper';
import { routes as editMessagesWiseRoutes } from './views/Messages/EditMessages/editMessages.wise.routes';
import { routes as dashboardWiseRoutes } from './views/Dashboard/dashboard.wise.routes';
import { routes as createMessagesWiseRoutes } from './views/Messages/CreateMessages/createMessages.wise.routes';
import { routes as connectionWise } from './views/Connection/connection.wise.routes';
import { routes as profileWise } from './views/Profile/profileWise.routes';
import { routes as integrationsWise } from './views/Integrations/integrationsWise.routes';
export const routes = [
  {
    path: frontendURL('accounts/:accountId/wise'),
    name: 'wise',
    roles: ['administrator'],
    component: WiseView,
  },
  ...createMessagesWiseRoutes,
  ...editMessagesWiseRoutes,
  ...dashboardWiseRoutes,
  ...connectionWise,
  ...profileWise,
  ...integrationsWise,
];
